import { render, staticRenderFns } from "./RegistrationNumbersDataTable.vue?vue&type=template&id=35f92be3&scoped=true&"
import script from "./RegistrationNumbersDataTable.vue?vue&type=script&lang=js&"
export * from "./RegistrationNumbersDataTable.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationNumbersDataTable.vue?vue&type=style&index=0&id=35f92be3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f92be3",
  null
  
)

export default component.exports